import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleGestionarClienteDisconforme = React.lazy(
  () =>
    import(
      "../components/task/accountManager/tareaDetalleGestionarClienteDesconforme/tarea-detalle-gestionar-cliente-desconforme"
    )
);
export function tareaDetalleGestionarClienteDisconforme() {
  return (
    <Route
      path="/tarea-detalle-gestionar-cliente-disconforme"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleGestionarClienteDisconforme />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
